import { useCurrentUser } from '@/hooks/useCurrentUser';
import { hasAtLeast } from '@/lib/roles';
import type { ClientRole } from '@/types/user';

export function useHasRole(min: ClientRole): boolean {
  const { data: user } = useCurrentUser();
  return hasAtLeast(user?.clientRole, min);
}
